import React from "react";
import axios from "axios";
import LightTile from "./LightTile";

export default class LightGrid extends React.Component {

    constructor(props){
        super(props);
        this.state = { books: [], isLoaded: false }
    }

    componentDidMount() {
        axios.get('https://theallfathersdomain.000webhostapp.com/wp-json/wp/v2/books')
            .then(res => this.setState({
                books: res.data,
                isLoaded: true
            }))
            .catch(err => console.log(err))
    }

    render(){

        const { books, isLoaded } = this.state;

        if(isLoaded){
            return(
                <div className="light-grid-container">
                    <div className="light-grid">
                        {books.map(book => {
                            return <LightTile key={book.id} book={book} />
                        })}
                    </div>
                </div>
            )
        } else {
            return  (
                <div>Loading...</div>
            )
        }
    }
}